<template>
  <div>
    <expansion v-model="isExpanded">
      <template slot="default">
        <section class="menu-option px-5 py-2">
          <div style="width: 12px">
            <expanded-icon :isExpanded="isExpanded"/>
          </div>
          <h3>{{ this.label }}</h3>
          <add-btn v-if="addBtn" @click="handleAdd"/>
        </section>
      </template>

      <template slot="expanded">
        <section class="px-5 pt-3">
          <slot></slot>
        </section>
      </template>
    </expansion>
    <hr v-if="divider" class="divider"/>
  </div>
</template>

<script>
import Expansion from '../../_v2/ui/Expansion.vue'
import AddBtn from '../../_v2/ui/AddBtn.vue'
import ExpandedIcon from '../../_v2/utils/ExpandedIcon.vue'

export default {
  name: 'MenuSection',
  components: {Expansion, AddBtn, ExpandedIcon},
  props: {
    value: {type: Boolean, required: true},
    label: {type: String, default: 'Menu expansivel'},
    divider: {type: Boolean, default: true},
    addBtn: {type: Boolean, default: true}
  },
  computed: {
    isExpanded: {
      get () { return this.value},
      set (v) { this.$emit('input', v) }
    }
  },

  methods: {
    handleAdd () {
      this.$emit('add')
    }
  }
}
</script>

<style scoped>
  .menu-option {
    display: flex;
    gap: 8px;
    align-items: flex-start;
    color: #24252D
  }

  .menu-option h3 {
    flex: 1;
    font-size: 16px;
    font-weight: 700;
  }

  .divider {
    margin: 24px 8px 16px 8px;
    border: none;
    height: 1px;
    background-color: rgba(102, 109, 128, 0.1);
  }    
</style>